export default __webpack_public_path__ + "static/media/labirynth2.a7ce7f49.svg";